import React from 'react'
import { Col, FormGroup, Row, Glyphicon } from 'react-bootstrap'
import { BusinessAcquirementCombo,BusinessOwnershipCombo, BusinessPremisesCombo, GeographicMarketCombo, Address, PhoneBox, DocumentUpload } from 'areas/shared/controls'
import { TextBox, IntBox, TextAreaBox, Switch, CheckBox, UrlBox, CurrencyBox, EmailBox, MaskedBox } from 'fw/forms'
import { CommentsGrid, ReviewUpload, AdminAppIdHeader } from 'areas/shared/components';
import { SetupTab } from 'areas/shared/pages/setup'
import { Label, Button, ActionButton, Tooltip } from 'fw/components'
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import * as Modals from 'fw/globals/Modals';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import * as Notifications from 'fw/globals/Notifications';
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel'
import * as ReportManager from 'modules/reports/ReportManager';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import OnlinePaymentInfoPopUp from './OnlinePaymentInfoPopUp';
import PreQualificationInfoPopUp from './PreQualificationInfoPopUp';
import TrackItPopUp from 'areas/admin/certification/shared/TrackItPopUp';
import UploadsConfig from './UploadsConfig';
import { QueueType, TooltipCode } from 'areas/shared/consts';
import ChangeCertificationType from 'areas/admin/certification/shared/ChangeCertificationType';
import SystemAPI from 'fw/system/API';

class CompanyInfo extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            phones: [],
            showOnlinePaymentInfoPopUp: false,
            showPreQualificationInfoPopUp: false,
            showTrackItPopUp: false,
            vobDba: [],
            reviewUploads: [],
            reviewComment: '',
            tooltips: [],
            declarationDocuments: [],
            grossRevenueDocuments: [],
            allowEditVobSales: true
        }
    }

    skipValidations() {
        return App.hasPrivilege("AdminSkipValidations");
    }

    onOnlinePaymentInfoClose = () => {
        this.setState({
            showOnlinePaymentInfoPopUp: false
        });
    }

    onOnlinePaymentInfoClick = () => {

        if (this.state.form.onlinePayment !== null || this.state.form.paymentInfoStorageToken === null) {
            this.setState({
                showOnlinePaymentInfoPopUp: true
            });
        }
        else if (this.state.form.paymentInfoStorageToken !== null) {
            new SystemAPI().download({
                storageToken: this.state.form.paymentInfoStorageToken,
                fileName: this.state.form.paymentInfoFileName
            });
        }
    }

    onPreQualificationInfoClose = () => {
        this.setState({
            showPreQualificationInfoPopUp: false
        });
    }

    onPreQualificationInfoClick = () => {
        this.setState({
            showPreQualificationInfoPopUp: true
        });
    }

    onTrackItClick = () => {
        this.setState({
            showTrackItPopUp: true
        });
    }

    onTrackItClose = (data) => {
        this.setState({
            showTrackItPopUp: false,
            form: {
                ...this.state.form,
                ...data
            }
        });

		// Reload tab to refresh logs if Track It data changed
		if (data.trackingData)
			this.reload();
    }

    onUntrackClick = () => {
        Modals.confirm("Do you want to untrack this certification?", () => {
                API.Admin.post('/certification/untrackCertification', { certificationId: this.state.form.certificationId },
                    {
                        success: (sr) => {
                            this.props.onSuccess(sr.message);

                            this.setState({
                                form: {
                                    ...this.state.form,
                                    ...sr.data
                                }
                            });

							// Reload tab to refresh logs
							this.reload();
                        },
                        error: (sr) => {
                            Notifications.error(sr.error.errorMessage);
                        }
                    }
                )
            }
        );
    }

    updatePostData = (form, dirty) => {
        for (var ref in this.refs) {
            this._form.register(this.refs[ref]);
        }
        if (this._businessAddress !== null)
            this._businessAddress.register(this._form);
        if (this._mailingAddress !== null && !this.state.form.sameMailingAddress)
            this._mailingAddress.register(this._form);

        if (this.state.form.showComplete)
            this.validateReviewStatus(form);
        this.setState({ form })

        if (dirty === true) this.dirt()
    }

    validateReviewStatus = (form) => {
        let isRenewal = this.state.form.certificationTypeCode === "REN";
        let canComplete =
            (
                this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
            ) ||
            (this.state.form.reviewUploads.every((reviewUpload) => { return reviewUpload.validDocument || reviewUpload.validDocument === null; })
                && (this.state.form.declarationDocuments.every((item) => { return item.uploadModel && (item.uploadModel.validDocument || item.uploadModel.validDocument === null); }))
                && (this.state.form.grossRevenueDocuments.length === 0 || this.state.form.grossRevenueDocuments.every((item) => { return item.uploadModel && (item.uploadModel.validDocument || item.uploadModel.validDocument === null); }))
                && (isRenewal || this.state.form.vobDba.every((item) => { return item.reviewUpload ? item.reviewUpload.validDocument : false; })));

        if (form.reviewStatus !== null && form.reviewStatus !== undefined && form.reviewStatus && !canComplete)
            form.reviewStatus = false;
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    handleBusinessOwnershipUploadChange = (file) => {
        let form = this.state.form
        form.businessOwnershipStorageToken = file.storageToken
        form.businessOwnershipFileName = file.fileName

        this.updatePostData(form, true)
    }

    handlePaymentInfoUploadChange = (file) => {
        let form = this.state.form
        form.paymentInfoStorageToken = file.storageToken
        form.paymentInfoFileName = file.fileName
        // To update the Payment Info popup
        if (form.onlinePayment) {
            form.onlinePayment.paymentInfoStorageToken = file.storageToken
            form.onlinePayment.paymentInfoFileName = file.fileName
        }

        this.updatePostData(form, true)
    }

    handleAddPhone = () => {
        const phones = this.state.form.phones

        phones.push({
            phoneTypeCode: 'MOBILE',
            number: '',
            extension: '',
            phoneId: -Math.abs(Date.now() | 0)
        })

        this.setState({
            phones
        })
    }

    handleRemovePhone = (i) => {
        const phones = this.state.form.phones;

        phones[i].number = '';
        phones.splice(i, 1);

        this.setState({ form: { ...this.state.form, phones } })
        this.dirt()
    }

    handlePhoneChange = (v, i) => {
        const phones = this.state.form.phones

        phones[i] = v

        this.setState({ form: { ...this.state.form, phones } })
        this.dirt()
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: 'VobInfoReport',
            format: 'PDF',
            parameters: {
                vobId: this.state.form.savedEntityId,
                CertificationId: this.state.form.certificationId
            }
        })

        ReportManager.execute(rq)
    }

    renderPhones = () => {
        return (
            this.state.form.phones.map((p, i) => (
                <div key={p.phoneId} className='form-inline'>
                    <PhoneBox
                        value={p}
                        showExtension
                        onChange={(v) => this.handlePhoneChange(v, i)}
                        required={i === 0 ? "required" : ""}
                        ref={`phone_${i}`}
                    />
                    {i > 0 ?
                        <Button id="btnRemovePhone" bsStyle='link' title='Remove Phone' onClick={() => this.handleRemovePhone(i)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </Button> : null}
                </div>
            ))
        )
    }

    privileges() {
        return {
            edit: App.hasPrivilege("AdminAppManagementEdit")
        }
    }

    handleApproveAssociation = (e) => {
        const rq = {
            vobId: this.state.form.savedEntityId
        };

        this.setState({ error: null }, function () {
            API.Admin.post('/certification/approveAssociation', rq,
                {
                    success: (sr) => {
                        this.props.onSuccess(sr.message);
                        let form = this.state.form;
                        form.showAssociationRequest = false;
                        this.updatePostData(form, true);
                    },
                    error: (sr) => {
                        Notifications.error(sr.error.errorMessage);
                    }
                });
        });
    }

    handleDenyAssociation = (e) => {
        const rq = {
            vobId: this.state.form.savedEntityId
        }

        this.setState({ error: null }, function () {
            API.Admin.post('/certification/denyAssociation', rq,
                {
                    success: (sr) => {
                        this.props.onSuccess(sr.message);
                        let form = this.state.form;
                        form.showAssociationRequest = false;
                        this.updatePostData(form, true);
                    },
                    error: (sr) => {
                        Notifications.error(sr.error.errorMessage);
                    }
                });
        });
    }

    urls() {
        return {
            get: API.Admin.url('/certification/getVOBInfo'),
            save: API.Admin.url('/certification/saveVobInfo')
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
            queueTypeCode: this.props.queueTypeCode
        }
    }

    saveRequest() {
        return {
            certificationId: this.state.form.certificationId,
            vobFein: this.state.form.vobFein,
            vobId: this.state.form.savedEntityId,
            vobName: this.state.form.vobName,
            website: this.state.form.website,
            email: this.state.form.email,
            businessAddress: this.state.form.businessAddress,
            mailingAddress: this.state.form.mailingAddress,
            sameMailingAddress: this.state.form.sameMailingAddress,
            dba: this.state.form.dba,
            reviewUploads: this.state.form.reviewUploads,
            declarationDocuments: this.state.form.declarationDocuments,
            businessOwnershipId: this.state.form.businessOwnershipId,
            businessOwnershipExplanation: this.state.form.businessOwnershipExplanation,
            geographicMarketId: this.state.form.geographicMarketId,
            businessPremisesId: this.state.form.businessPremisesId,
            businessAcquirementId: this.state.form.businessAcquirementId,
            businessAcquirementExplanation: this.state.form.businessAcquirementExplanation,
            yearBusinessFormed: this.state.form.yearBusinessFormed,
            yearVeteranBusiness: this.state.form.yearVeteranBusiness,
            grossRevenue1Year: this.state.form.grossRevenue1Year,
            grossRevenue1Amount: this.state.form.grossRevenue1Amount,
            grossRevenue2Year: this.state.form.grossRevenue2Year,
            grossRevenue2Amount: this.state.form.grossRevenue2Amount,
            applicationFee: this.state.form.applicationFee,
			discountAmount: this.state.form.discountAmount,
			paymentAmount: this.state.form.paymentAmount,
            grossRevenueDocuments: this.state.form.grossRevenueDocuments,
            businessOwnershipStorageToken: this.state.form.businessOwnershipStorageToken,
            businessOwnershipFileName: this.state.form.businessOwnershipFileName,
            paymentInfoStorageToken: this.state.form.paymentInfoStorageToken,
            paymentInfoFileName: this.state.form.paymentInfoFileName,
            phones: this.state.form.phones,
            vobDba: this.state.form.vobDba,
            rowVersion: this.state.form.rowVersion,
            reviewStatus: this.state.form.reviewStatus,
            reviewQueueTypeCode: this.state.form.certificationQueueTypeCode,
            reviewComment: this.state.reviewComment
        }
    }

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    isValidated(data) {
        return data.isSubmitted;
    }

    ready = () => {
        this.focusControl && this.focusControl.focus()
        if (this.state.form.phones.length === 0)
            this.handleAddPhone();
        if (this.state.form.dba && this.state.form.vobDba.length === 0)
            this.addAnotherDba();
        if (this.state.form.declarationDocuments.length === 0)
            this.addDeclarationDocument();
        if (this.state.form.grossRevenueDocuments.length === 0)
            this.addGrossRevenueDocument();
    }

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form["reviewStatus"] = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    handleCertificationTypeChange = (data) => {
        let form = {
            ...this.state.form,
            certificationType: data.certificationTypeDescription,
            certificationTypeCode: data.certificationTypeCode
        };
        this.updatePostData(form, false);

        // Add reviewer log comment
        if (data.reviewComment) {
            let comments = this.state.form.comments || [];
            comments.unshift({
                commentId: data.reviewComment.commentId,
                reviewTypeDescription: data.reviewComment.reviewTypeDescription,
                queueTypeDescription: data.reviewComment.queueTypeDescription,
                content: data.reviewComment.content,
                addedDate: data.reviewComment.addedAt,
                addedBy: data.reviewComment.addedBy,
                commentTypeCode: data.reviewComment.commentTypeCode
            });
            this.setState({ form: { ...this.state.form, comments } });
        }
    }

    checkBlankDBAFields = () => {
        let form = this.state.form;
        if (!this.state.form.dba)
            form.vobDba = [];
        else {
            if (this.state.form.vobDba.length === 0)
                this.addAnotherDba();
        }

        this.updatePostData(form, true)
    }

    checkBlankBusinessOwnershipExplanation = () => {
        let form = this.state.form;
        if (this.state.form.businessOwnershipId !== 6) {
            form.businessOwnershipExplanation = null;
            form.businessOwnershipStorageToken = null;
            form.businessOwnershipFileName = null;
        }

        this.updatePostData(form, true)
    }

    checkBlankBusinessAcquirementExplanation = () => {
        let form = this.state.form;
        if (this.state.form.businessAcquirementId !== 5) {
            form.businessAcquirementExplanation = null;
        }

        this.updatePostData(form, true)
    }

    checkBlankMailingAddressFields = () => {
        let form = this.state.form;
        form.mailingAddress = null;

        this.updatePostData(form, true)
    }

    addAnotherDba = () => {
        let form = this.state.form;
        form.vobDba.push({});

        this.updatePostData(form);
    }

    handleOtherDbaRemove = (index) => {
        let form = this.state.form;
        form.vobDba[index].name = "";
    };

    handleReviewUploadDbaDocumentChange = (formUpload, index) => {
        let form = this.state.form;

        form.vobDba[index].reviewUpload = formUpload;

        this.updatePostData(form, true);
    }

    handleDbaNameChange = (value, index) => {
        let form = this.state.form;
        form.vobDba[index].name = value;

        this.updatePostData(form, true);
    };

    handleRemoveDbaDocument = (i) => {
        let form = this.state.form;
        form.vobDba.splice(i, 1);

        this.updatePostData(form, true);
    };

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
    }

    addCommentFromSave = (comment) => {
        if (comment === null)
            return;

        let comments = this.state.form.comments;

        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderDbaFiles = (isRenewal) => {
        return this.state.form.vobDba.map((item, index) => (
            <Row key={index} style={{ marginBottom: 10 }}>
                <Col md={1} style={{ marginTop: 5, textAlign: "left", marginLeft: -25, paddingLeft: 0 }}>
                    {index > 0 ?
                        <div>
							<Button type="button" bsStyle="link" onClick={() => this.handleRemoveDbaDocument(index)} title="Remove Financial Document">
                                <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
							</Button>
                        </div>
                        : null}
                </Col>
                <Col md={11}>
                    <ReviewUpload
                        reviewUpload={item.reviewUpload}
                        reviewDisabled={isRenewal}
                        // config={UploadsConfig}
                        formatInline={false}
                        onChange={formUpload => this.handleReviewUploadDbaDocumentChange(formUpload, index)}
                        onRemove={() => this.handleOtherDbaRemove(index)}
                        notApplicableAvailable={false}
                        wrapFileNameLength={30}
                        queueTypeCode={this.state.form.certificationQueueTypeCode} />
                    <Label htmlFor={`dbaName_${index}`} required>DBA Name</Label>
                    <TextAreaBox
                        formControl={false}
                        name={`dbaName_${index}`}
                        value={item.name}
                        placeholder='Please enter other Business Name'
                        maxLength={50}
                        onChange={value => this.handleDbaNameChange(value, index)}
                    />
                </Col>
            </Row>
        ));
    };

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'CI'}
                queueTypeCode={this.state.form.certificationQueueTypeCode}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                        <Row>
                            <Col md={12}>
                                <div className="pull-left">
                                    {this.state.form.showAssociationRequest ?
                                        <React.Fragment>
                                            <Button id="btnDenyAssociation" bsStyle="default" disabled={false} onClick={this.handleDenyAssociation} style={{ marginRight: 5, width: 150 }}>Deny Association</Button>
                                            <Button id="btnApproveAssociation" bsStyle="primary" disabled={false} onClick={this.handleApproveAssociation} style={{ marginRight: 5, width: 150 }}>Approve Association</Button>
                                        </React.Fragment>
                                        : null}
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={6}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderUploadFields = () => {
        var me = this;
        return this.state.form.reviewUploads.map((item, index) => (
            me.renderUploadField(item)
        ));
    }

    renderUploadField = (reviewUpload) => {
        var me = this;
        const uploadKey = reviewUpload.upload.uploadKey;
        const availableQueues = [QueueType.APPLICATION_REVIEW.code, QueueType.COMMITTEE_REVIEW.code, QueueType.CERTIFICATION_REVIEW.code];

        return (
            <ReviewUpload
                disabled={!me.state.enabled}
                key={uploadKey}
                reviewUpload={reviewUpload}
                config={UploadsConfig}
                onChange={this.handleReviewUpload}
                notApplicableAvailable={false}
                queueTypeCode={this.state.form.certificationQueueTypeCode}
                availableQueues={availableQueues}
                triState={true}
                tip={this.setTip(UploadsConfig[uploadKey].tooltipCode)} />
        );
    }

    handleReviewUpload = (formUpload) => {
        let form = this.state.form;
        var items = form.reviewUploads;

        var foundIndex = items.findIndex(x => x.upload.uploadKey === formUpload.upload.uploadKey);
        if (foundIndex === -1) {
            items.push(formUpload);
        }
        else {
            items[foundIndex] = formUpload;
        }

        form["reviewUploads"] = items;

        this.updatePostData(form, true);
    }

    addDeclarationDocument = () => {
        let form = this.state.form;
        form.declarationDocuments.push({
            vobDeclarationDocumentId: -Math.abs(Date.now() | 0),
            uploadModel: { validDocument: null }
        });

        this.updatePostData(form);
    };

    renderDeclarationDocuments = () => {
        return this.state.form.declarationDocuments.map((item, index) => {
            let removeComponent =
                index > 0 ?
                    <Col md={1} style={{ marginTop: 5, textAlign: "left", marginLeft: -25, paddingLeft: 0 }}>
						<Button type="button" bsStyle="link" onClick={() => this.handleRemoveDeclarationDocument(index)} title="Remove Declaration Supporting Document">
                            <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
						</Button>
                    </Col>
                    : null;

            return (
                <Row key={item.vobDeclarationDocumentId}>
                    <Col md={12}>
                        <ReviewUpload
                            reviewUpload={item.uploadModel}
                            onChange={formUpload => this.handleUploadDeclarationDocumentChange(formUpload, index)}
                            notApplicableAvailable={false}
                            queueTypeCode={this.state.form.certificationQueueTypeCode}
                            toolbarComponent={removeComponent}
                            triState={true} />
                    </Col>
                </Row>
            )
        });
    };

    handleUploadDeclarationDocumentChange = (formUpload, index) => {
        let form = this.state.form;
        form.declarationDocuments[index].uploadModel = formUpload;

        this.updatePostData(form, true)
    };

    handleRemoveDeclarationDocument = (i) => {
        let form = this.state.form;
        form.declarationDocuments.splice(i, 1);

        this.updatePostData(form, true);
    }

    addGrossRevenueDocument = () => {
        let form = this.state.form;

        form.grossRevenueDocuments.push({
            vobGrossRevenueDocumentId: -Math.abs(Date.now() | 0),
            uploadModel: { validDocument: null }
        });

        this.setState({ form: form });
    };

    handleUploadGrossRevenueDocumentChange = (formUpload, index) => {
        let form = this.state.form;
        form.grossRevenueDocuments[index].uploadModel = formUpload;

        this.updatePostData(form, true)
    };

    handleRemoveGrossRevenueDocument = (i) => {
        let form = this.state.form;

        form.grossRevenueDocuments.splice(i, 1);

        this.updatePostData(form, true);
    }

    renderGrossRevenueDocuments = () => {
        return this.state.form.grossRevenueDocuments.map((item, index) => {
            let removeComponent =
                index > 0 ?
                    <Col md={1} style={{ marginTop: 5, textAlign: "left", marginLeft: -25, paddingLeft: 0 }}>
						<Button type="button" bsStyle="link" onClick={() => this.handleRemoveGrossRevenueDocument(index)} title="Remove Gross Revenue Supporting Document">
                            <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
						</Button>
                    </Col>
                    : null;

            return (
                <Row key={item.vobGrossRevenueDocumentId}>
                    <Col md={12}>
                        <ReviewUpload
                            reviewUpload={item.uploadModel}
                            onChange={formUpload => this.handleUploadGrossRevenueDocumentChange(formUpload, index)}
                            notApplicableAvailable={false}
                            queueTypeCode={this.state.form.certificationQueueTypeCode}
                            toolbarComponent={removeComponent}
                            triState={true} />
                    </Col>
                </Row>
            )
        });
    };

    renderTrackItButtons = () => {
        if (App.hasPrivilege("AdminAppTrackCertification") && this.state.form.certificationId > 13300) {
            let hasTrackingData = this.state.form.trackingData;

            return (
                <React.Fragment>
                    <div className='pull-right' style={{ marginTop: 5 }}>
                        <ActionButton id='btnPrequal' onClick={this.onTrackItClick} icon={hasTrackingData ? 'edit' : 'exclamation-sign'} style={{ width: 80 }}>
                            {hasTrackingData ? "Edit Track" : "Track It"}
                        </ActionButton>
                    </div>
                    {hasTrackingData &&
                        <div className='pull-right' style={{ marginTop: 5 }}>
                            <ActionButton id='btnPrequal' onClick={this.onUntrackClick} icon='remove-sign' style={{ width: 80 }}>
                                Untrack
                            </ActionButton>
                        </div>
                    }
                    <TrackItPopUp
                        certificationId={this.state.form.certificationId}
                        isModifying={hasTrackingData}
                        trackingData={this.state.form.trackingData || ""}
						discountCode={this.state.form.discountCode || ""}
                        visible={this.state.showTrackItPopUp}
                        onClose={this.onTrackItClose}
                    />
                </React.Fragment>
            );
        }
    }

    renderForm() {

        let me = this;
        let certificationTypeExtendedCode = this.state.form.certificationTypeCode;
        if (certificationTypeExtendedCode === "REN")
            certificationTypeExtendedCode += this.state.form.renewalNumber;

        let isRenewal = this.state.form.certificationTypeCode === "REN";
        let certificationStatus = (this.state.form.certificationStatus === "Started") ? "PreQualification" : this.state.form.certificationStatus;

        return (
            <React.Fragment>
                <Row>
                    <Col md={12} className="panel-header">
                        <h3>
                            <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} />
                        </h3>
                        <div className="panel-header-actions">
                            {App.hasPrivilege("AdminAppChangeCertificationType") ?
                                (<ChangeCertificationType
                                    certificationId={this.state.form.certificationId}
                                    certificationTypeCode={certificationTypeExtendedCode}
                                    visible={App.hasPrivilege("AdminAppChangeCertificationType")}
                                    onChange={(data) => this.handleCertificationTypeChange(data)} />) : null}
                            {!!this.state.form.certificationType && (
                                <h4>
                                    {this.state.form.certificationType} – {certificationStatus}
                                </h4>
                            )}
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <hr />
                        <h3 style={{ marginTop: "0px" }}>
                            Company Information – <small>Please submit all required Company Information</small>
                            {this.renderAdminStepToolbar()}
                            <div className='pull-right'>
                                <ActionButton id='btnPrint' onClick={this.handlePrint} icon='print' bsSize='sm'>
                                    Print
                                </ActionButton>
                            </div>
                        </h3>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={5}>
                        <FormGroup>
                            <Label htmlFor="vobName" tip={this.setTip(TooltipCode.COMPANY.COMPANYNAME)} required>
                                Company Name
                                    </Label>
                            <TextBox
                                required
                                name='vobName'
                                placeholder="Company Name"
                                maxLength={128}
                                ref={(c) => {
                                    this.focusControl = c
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor="vobFein" tip={this.setTip(TooltipCode.COMPANY.COMPANYFEIN)} required>
                                Company FEIN/EIN
                                    </Label>
                            <MaskedBox
                                name="vobFein"
                                placeholder="Company FEIN/EIN"
                                required mask="99-9999999"
                                alwaysShowMask={false}
                                maskChar=""
                                disabled={!this.state.enabled
                                    || (this.props.selectedId !== null && this.props.selectedId !== undefined && this.state.form.certificationTypeCode !== "CER")
                                    || (this.props.selectedId !== null && this.props.selectedId !== undefined && !App.hasPrivilege("AdminAppVobFeinEdit"))} />
                        </FormGroup>
                        {this.state.form.phones !== null && this.state.form.phones.length > 0 && (
                            <FormGroup>
                                <Label htmlFor="phoneNumber" tip={this.setTip(TooltipCode.COMPANY.PHONENUMBER)} required>Phone Number(s)</Label>
                                {this.renderPhones()}
                            </FormGroup>
                        )}
                        {this.state.form.phones !== null && this.state.form.phones.length < 5 && (
                            <Button id="btnAddPhone" bsStyle='default' bsSize='xsmall' className='pull-right' onClick={this.handleAddPhone}>
                                Add Phone
                                <Glyphicon glyph='plus' style={{ marginLeft: 10 }} />
                            </Button>
                        )}
                        <FormGroup style={{ marginTop: '35px' }}>
                            <Label htmlFor="website" tip={this.setTip(TooltipCode.COMPANY.WEBSITE)}>Company Website</Label>
                            <UrlBox
                                name='website'
                                placeholder='Company Website'
                                maxLength={200}
                            />
                        </FormGroup>
                        <FormGroup style={{ marginTop: '35px' }}>
                            <Label htmlFor="email" tip={this.setTip(TooltipCode.COMPANY.EMAIL)} required>Company Email</Label>
                            <EmailBox required 
                                name="email"
                                placeholder='Company Email'
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor="dba" tip={this.setTip(TooltipCode.COMPANY.DOINGBUSINESS)}>
                                Does your Business operate with a “Doing Business As” (DBA) name?
                                    </Label>
                            <Row>
                                <Col md={3}>
                                    <Switch onChange={this.checkBlankDBAFields} name='dba' labelLeft='No' labelRight='Yes' bsStyle='primary' />
                                </Col>
                                <Col md={9}>
                                    {this.state.form !== null && this.state.form.dba ? (
                                        <React.Fragment>
                                            <FormGroup>
                                                {this.state.form.vobDba != null && this.state.form.vobDba.length > 0 && this.renderDbaFiles(isRenewal)}
                                            </FormGroup>
                                            {this.state.form.vobDba != null && this.state.form.vobDba.length < 5 && (
                                                <Button bsStyle="default" bsSize="xsmall" className="pull-right" onClick={this.addAnotherDba}>Add DBA<Glyphicon glyph="plus" style={{ marginLeft: 10 }} /></Button>
                                            )}
                                        </React.Fragment>
                                    ) : null}
                                </Col>
                            </Row>
                        </FormGroup>
                    </Col>
                    <Col md={1}></Col>
                    <Col md={5}>
                        <FormGroup>
                            <Label htmlFor="businessOwnershipId" tip={this.setTip(TooltipCode.COMPANY.BUSINESSOWNERSHIP)} required>Business Ownership</Label>
                            <BusinessOwnershipCombo onChange={this.checkBlankBusinessOwnershipExplanation} required name='businessOwnershipId' placeholder="Business Ownership" />
                        </FormGroup>
                        {this.state.form !== null && this.state.form.businessOwnershipId === 6 ? ( // Change this to ask for 'Other'
                            <React.Fragment>
                                <TextAreaBox
                                    required
                                    name='businessOwnershipExplanation'
                                    maxLength={200}
                                    placeholder='Please explain using this text field, and upload a document of explanation below'
                                />
                                <DocumentUpload
                                    storageToken={this.state.form.businessOwnershipStorageToken}
                                    fileName={this.state.form.businessOwnershipFileName}
                                    onChange={this.handleBusinessOwnershipUploadChange}
                                />
                            </React.Fragment>
                        ) : null}
                        <FormGroup>
                            <Label htmlFor="geographicMarketId" tip={this.setTip(TooltipCode.COMPANY.GEOGRAPHICMARKET)} required>Business Geographic Market</Label>
                            <GeographicMarketCombo required name='geographicMarketId' placeholder="Business Geographic Market" />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor="businessPremisesId" tip={this.setTip(TooltipCode.COMPANY.BUSINESSPREMISES)} required>
                                Type of Business Premises
                                    </Label>
                            <BusinessPremisesCombo required name='businessPremisesId' placeholder="Type of Business Premises" />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor="businessAcquirementId" tip={this.setTip(TooltipCode.COMPANY.BUSINESSACQUIREMENT)} required>How was the Business Acquired?</Label>
                            <BusinessAcquirementCombo onChange={this.checkBlankBusinessAcquirementExplanation} required name='businessAcquirementId' placeholder="How was the Business Acquired?" />
                        </FormGroup>
                        {this.state.form !== null && this.state.form.businessAcquirementId === 5 ? ( // Change this to ask for 'Other'
                            <React.Fragment>
                                <TextAreaBox
                                    required
                                    name='businessAcquirementExplanation'
                                    maxLength={200}
                                    placeholder='Please explain using this text field'
                                />
                            </React.Fragment>
                        ) : null}
                        <FormGroup>
                            <Label htmlFor="yearBusinessFormed" tip={this.setTip(TooltipCode.COMPANY.YEARBUSINESSFORMED)} required>
                                What year did your company begin?
                                    </Label>
                            <IntBox
                                required
                                disabled={!this.state.form.allowEditVobSales}
                                name="yearBusinessFormed"
                                placeholder="What year did your company begin?"
                                maxLength={4} />
                        </FormGroup>
                        <FormGroup>
                            <Label htmlFor="yearVeteranBusiness" tip={this.setTip(TooltipCode.COMPANY.YEARVETERANCOMPANY)} required>
                                What year did the veteran(s) become the controlling owner?
                                    </Label>
                            <IntBox
                                required
                                disabled={!this.state.form.allowEditVobSales}
                                name="yearVeteranBusiness"
                                placeholder="What year did the veteran(s) become the controlling owner?"
                                maxLength={4} />
                        </FormGroup>
                    </Col>
                    <Col md={1} style={{ marginTop: 5 }}>
                        <div className='pull-right' >
                            <ActionButton id='btnPayment' onClick={this.onOnlinePaymentInfoClick} icon='info-sign' style={{ width: 80 }}>
                                Payment
                            </ActionButton>
                        </div>
                        <OnlinePaymentInfoPopUp
                            certificationId={this.state.form.certificationId}
                            visible={this.state.showOnlinePaymentInfoPopUp}
                            onClose={this.onOnlinePaymentInfoClose}
                            onlinePayment={this.state.form.onlinePayment} />
                        <div className='pull-right' style={{ marginTop: 5 }}>
                            <ActionButton id='btnPrequal' onClick={this.onPreQualificationInfoClick} icon='info-sign' style={{ width: 80 }}>
                                Prequal
                            </ActionButton>
                        </div>
                        <PreQualificationInfoPopUp
                            certificationId={this.state.form.certificationId}
                            visible={this.state.showPreQualificationInfoPopUp}
                            onClose={this.onPreQualificationInfoClose}
                            prequalificationInfo=
                            {{
                                questionnaire: this.state.form.questionnaire,
                                grossRevenue1Year: this.state.form.grossRevenue1Year,
                                grossRevenue1Amount: this.state.form.grossRevenue1Amount,
                                grossRevenue2Year: this.state.form.grossRevenue2Year,
                                grossRevenue2Amount: this.state.form.grossRevenue2Amount
                            }} />
                        {this.renderTrackItButtons()}
                    </Col>
                </Row>
                <Row>
                </Row>
                {this.state.form.showDeclaration ?
                    <React.Fragment>
                        <Row>
                            <Col md={12}>
                                <h3>Declaration</h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <Row>
                                    <Col md={7}>
                                        {me.renderUploadFields()}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={7}>
                                        <Label htmlFor="declarationDocumentUpload" tip={this.setTip(TooltipCode.COMPANY.DECSUPDOC)}>Declaration Supporting Documents</Label>
                                        {this.state.form.declarationDocuments != null &&
                                            this.state.form.declarationDocuments.length > 0 && (
                                                <React.Fragment>
                                                    {this.renderDeclarationDocuments()}
                                                    {(this.state.form.declarationDocuments === null || this.state.form.declarationDocuments.length < 5) &&
														<Button type="button" bsStyle="link" onClick={this.addDeclarationDocument}>
                                                            Add another Declaration Supporting Document
														</Button>
													}
                                                </React.Fragment>
                                            )
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </React.Fragment>
                    : null}
                <Row>
                    <Col md={6}>
                        <Row>
                            <Col md={12}>
                                <h3>Company Address</h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <FormGroup>
                                    <Address
                                        ref={(c) => { this._businessAddress = c }}
                                        required
                                        name='businessAddress'
                                    />
                                </FormGroup>
                                <CheckBox onChange={this.checkBlankMailingAddressFields} name='sameMailingAddress' label='Mailing Address same as Company Address' />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={6}>
                        <Row>
                            <Col md={12}>
                                <h3>Company Sales</h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>&nbsp;
                                    </Col>
                        </Row>
                        <Row>
                            <Col md={10}>
                                <Row>
                                    <Col md={12}>
                                        <Label> Enter Gross Revenue for the last 2 years </Label>
                                    </Col>
                                </Row>
                                <Row><Col>&nbsp;</Col></Row>
                                <Row>
                                    <Col md={10}>
                                        <Row>
                                            <Col md={3}>
                                                <Label> From Prequal </Label>
                                            </Col>
                                            <Col md={3}>
                                                <IntBox
                                                    disabled={!this.state.form.allowEditVobSales}
                                                    name="grossRevenue1Year"
                                                    maxLength={4} />
                                            </Col>
                                            <Col md={5}>
                                                <CurrencyBox
                                                    disabled={!this.state.form.allowEditVobSales}
                                                    name="grossRevenue1Amount"
                                                    positiveNumbersOnly
                                                    placeholder='Please provide whole numbers'
                                                    maxLength={15}
                                                    precision={0} />
                                            </Col>
                                            <Col md={1} style={{ margin: 0, padding: 0 }}>
                                                <Tooltip tip={me.setTip(TooltipCode.COMPANY.GROSSREVENUEFIRST)}
                                                    placement="left" />
                                            </Col>
                                        </Row>
                                        <Row><Col>&nbsp;</Col></Row>
                                        <Row>
                                            <Col md={3}>
                                                <Label> 2nd Year </Label>
                                            </Col>
                                            <Col md={3}>
                                                <IntBox name="grossRevenue2Year"
                                                    maxLength={4} />
                                            </Col>
                                            <Col md={5}>
                                                <CurrencyBox
                                                    name="grossRevenue2Amount"
                                                    placeholder='Please provide whole numbers'
                                                    positiveNumbersOnly
                                                    maxLength={15}
                                                    precision={0} />
                                            </Col>
                                            <Col md={1} style={{ margin: 0, padding: 0 }}>
                                                <Tooltip tip={me.setTip(TooltipCode.COMPANY.GROSSREVENUESECOND)}
                                                    placement="left" />
                                            </Col>
                                        </Row>
                                        <Row><Col>&nbsp;</Col></Row>
                                        <Row>
                                            <Col md={1}></Col>
                                            <Col md={5}>
                                                <Label> Application Fee </Label>
                                            </Col>
                                            <Col md={5}>
                                                <CurrencyBox
                                                    name="applicationFee"
                                                    disabled={!this.state.form.allowEditVobSales}
                                                    positiveNumbersOnly
                                                    onValidate = {(x) => { return (parseInt(x, 0) >= 1000000) ? "Invalid Input" : null }}
                                                    maxLength={10}
                                                    precision={2} />
                                            </Col>
                                            <Col md={1} style={{ margin: 0, padding: 0 }}>
                                                <Tooltip tip={me.setTip(TooltipCode.COMPANY.APPFEEPAID)}
                                                    placement="left" />
                                            </Col>
                                        </Row>
										<Row><Col>&nbsp;</Col></Row>
										<Row>
                                            <Col md={1}></Col>
                                            <Col md={5}>
                                                <Label> Discount Applied </Label>
                                            </Col>
                                            <Col md={5}>
                                                <CurrencyBox
                                                    name="discountAmount"
                                                    disabled={!this.state.form.allowEditVobSales}
                                                    positiveNumbersOnly
                                                    maxLength={10}
                                                    precision={2} />
                                            </Col>
                                        </Row>
										<Row><Col>&nbsp;</Col></Row>
										<Row>
                                            <Col md={1}></Col>
                                            <Col md={5}>
                                                <Label> Payment Amount </Label>
                                            </Col>
                                            <Col md={5}>
                                                <CurrencyBox
                                                    name="paymentAmount"
                                                    disabled={!this.state.form.allowEditVobSales}
                                                    positiveNumbersOnly
                                                    maxLength={10}
                                                    precision={2} />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={11}>
                                <Row><Col md={12}>&nbsp;</Col></Row>
                                <Row>
                                    <Col md={12}>
                                        <Label htmlFor="grossRevenueDocumentUpload" tip={this.setTip(TooltipCode.COMPANY.GROSSREVENUESUPDOC)}>Gross Revenue Supporting Documents</Label>
                                        {this.state.form.grossRevenueDocuments !== undefined &&
                                            this.state.form.grossRevenueDocuments.length > 0 && (
                                                <React.Fragment>
                                                    {this.renderGrossRevenueDocuments()}
                                                    {(this.state.form.grossRevenueDocuments.length < 5) &&
														<Button type="button" bsStyle="link" onClick={this.addGrossRevenueDocument}>
                                                            Add another Gross Revenue Supporting Document
														</Button>
													}
                                                </React.Fragment>
                                            )
                                        }
                                    </Col>
                                </Row>
                                <Row><Col md={12}>&nbsp;</Col></Row>
                                <Row>
                                    <Col md={12}>
                                        <Label>Payment Information Document</Label>
                                        <DocumentUpload
                                            storageToken={this.state.form.paymentInfoStorageToken}
                                            fileName={this.state.form.paymentInfoFileName}
                                            onChange={this.handlePaymentInfoUploadChange}
                                            wrapFileNameLength={40} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {this.state.form !== null && !this.state.form.sameMailingAddress ? (
                    <React.Fragment>
                        <Row>
                            <Col md={12}>
                                <h3>Mailing Address</h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Address
                                        ref={(c) => { this._mailingAddress = c }}
                                        required
                                        name='mailingAddress'
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </React.Fragment>
                ) : null}
                <Row>
                    <Col md={12}>
                        <br />
                    </Col>
                </Row>
                {this.state.form.showReview ?
                    <React.Fragment>
                        <Row>
                            <CommentsGrid
                                ref={(c) => { this._commentsGrid = c }}
                                comments={this.state.form.comments}
                                documents={this.state.form.reviewDocuments}
                                certificationKey={this.props.selectedId}
                                reviewTypeCode={'CI'}
                                queueTypeCode={this.state.form.certificationQueueTypeCode}
                                enableExport={true}
                                entityId={this.state.form.savedEntityId}
                                readonly={!this.state.privileges.edit || !this.state.enabled}
                                onSave={this.handleCommentsGrid}
                                onCommentChange={this.handleCommentChange}
                            />
                        </Row>
                        {this.state.form.showComplete ?
                            <Row>
                                <ReviewPanel stepName="Company Information"
                                    canComplete={
                                        (
                                            this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                                            this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                                            this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
                                        ) ||
                                        (this.state.form.reviewUploads.every((reviewUpload) => { return reviewUpload.validDocument || reviewUpload.validDocument === null; })
                                            && this.state.form.declarationDocuments.every((item) => { return item.uploadModel && (item.uploadModel.validDocument || item.uploadModel.validDocument === null); })
                                            && (this.state.form.grossRevenueDocuments.length === 0 || this.state.form.grossRevenueDocuments.every((item) => { return item.uploadModel && (item.uploadModel.validDocument || item.uploadModel.validDocument === null); }))
                                            && (isRenewal || this.state.form.vobDba.every((item) => { return item.reviewUpload ? item.reviewUpload.validDocument : false; })))}
                                    onChange={this.handleReviewStatus}
                                    reviewStatus={this.state.form.reviewStatus} />
                            </Row>
                            : null}
                    </React.Fragment>
                    : null}
            </React.Fragment>
        )
    }
}

export default CompanyInfo



// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/companyInfo/CompanyInfo.js